import React, { Fragment } from 'react'
import Loadable from 'react-loadable'

import { DI } from 'modules'
import HelmetWrap from 'components/helmet-wrap'
import HTMLTranslation from 'components/html-translation'
import page from 'hoc/page'
import frontload from 'hoc/frontload'

import 'submodules/responsivestyles/src/less/about.less'

const loading = () => null

const en = Loadable({
  loading,
  loader: () =>
    import(
      /* webpackChunkName: "cookie-policy-en" */ 'submodules/translations/static-pages/cookie-policy/en'
    ),
})

// const es = Loadable({
//   loading,
//   loader: () =>
//     import(
//       /* webpackChunkName: "cookie-policy-es" */ 'submodules/translations/static-pages/cookie-policy/es'
//     ),
// })

// const ar = Loadable({
//   loading,
//   loader: () =>
//     import(
//       /* webpackChunkName: "cookie-policy-ar" */ 'submodules/translations/static-pages/cookie-policy/ar'
//     ),
// })

const ar = en

export class CookiePage extends React.Component {
  static preload(props) {
    const slug = 'cookie'
    return props.actions.frontpages.getFrontPage(slug)
  }

  render() {
    const meta_tag = this.props.frontpages.info.payload.meta_tag
    return (
      <Fragment>
        <HelmetWrap {...(meta_tag || {})} page="cookies" />

        <section dir="ltr" className="content">
          <div className="iwrap not-found-page">
            <div className="about-container">
              <HTMLTranslation translations={{ en, ar }} />
            </div>
          </div>
        </section>
      </Fragment>
    )
  }
}

export default page(DI(['frontpages'])(frontload(CookiePage)))
